exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset {\n  border-bottom: 1px solid rgba(0, 115, 180, 0.25);\n  padding: 30px 0;\n}\n.asset__image {\n  height: 150px;\n  width: auto;\n  background-size: cover;\n}\n.asset__content {\n  margin-left: 30px;\n}\n.asset__title {\n  color: #0089c4;\n  font-weight: bold;\n}\n.asset.grid {\n  min-height: 390px;\n}\n.asset.grid .asset__content {\n  padding-top: 20px;\n}\n.asset.grid .asset__title {\n  min-height: 66px;\n}\n.asset.grid .asset__buttons {\n  min-height: 44px;\n}\n.icon-text-button {\n  display: inline-block;\n  margin-right: 15px;\n}\n.icon-text-button .icon {\n  float: none;\n  margin-right: 15px;\n  min-width: 20px;\n  display: inline-block;\n  color: #0089c4;\n}\n.icon-text-button .text {\n  position: relative;\n  display: inline-block;\n  top: -1px;\n  text-transform: capitalize;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/asset-library/asset/asset.component.scss
// module id = ../../../../../src/app/components/asset-library/asset/asset.component.scss
// module chunks = main